module.exports = __webpack_public_path__ + "img/IMG Vestuario.53adc518.jpg";